import { BaseSerializer } from './base.serializer'
import { ExamRegistration } from "../models";
import { DateSerializer, TimeSerializer } from "./attributes";

export class ExamRegistrationSerializer extends BaseSerializer<ExamRegistration> {
    static SERIALIZABLE_ATTRIBUTES = [
        'phone',
        'centerId',
        'target',
        'mechanics',
        'address',
        'scheduledAt',
        'centerId',
        'cityId',
        'firstName',
        'lastName',
        'middleName',
        'driverDbidUuid',
        'driverLicense',
        'licenseIssuedAt',
        'programId',
        'token',
        'sessionLink',
        'driverId',
        'uuid',
        'rating',
        'registrationLinkId'
    ];

    static SERIALIZERS = {
        licenseIssuedAt: DateSerializer,
        scheduledAt: TimeSerializer
    }

    static SERIALIZE_RENAME_KEYS = {
        driverLicense: 'licenseNumber',
        driverId: 'taxometerUuid'
    }

    static DESERIALIZERS = {
        licenseIssuedAt: DateSerializer,
        scheduledAt: TimeSerializer
    }

    static DESERIALIZE_RENAME_KEYS = {
    }

    static initializeObject(attributes: Object): ExamRegistration {
        return new ExamRegistration(attributes)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/exam-registration.serializer.ts